import * as React from "react";

const About = () => (
  <section id="about" className="border-t border-stone-200">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-3">
        <p className="text-xs uppercase tracking-[0.2em] text-stone-500">
          About
        </p>
      </div>
      <div className="lg:col-span-9 space-y-8 text-lg sm:text-xl text-stone-700 leading-relaxed font-light">
        <p>
          Huskly is where{" "}
          <a href="https://felipe.lima.gl" className="text-blue-500 underline">
            Felipe Lima
          </a>{" "}
          writes about Bitcoin treasury structures, leveraged carry strategies,
          and the mechanics of running a concentrated book. Research, code, and
          frameworks from an independent investor.
        </p>
        <p>
          We operate as a proprietary fund — investing our own capital in the
          strategies we develop. Huskly is not currently open to outside
          investors.
        </p>
        <p>
          Our work spans traditional equities and derivatives as well as digital
          assets. We are a crypto-native team, but our research is
          asset-agnostic and grounded in the same principles wherever it is
          applied.
        </p>
      </div>
    </div>
  </section>
);

export default About;
